module.exports = __webpack_public_path__ + "static/media/home-logo.ac4ab057.png";